import '../../../core/components/chart-grid/ChartGrid.css';
import './XYChartThresholdIndicators.css';
export var thresholdPlot = '_1mfu0sw0-3-8-0 _13lzg4k0-3-8-0';